module.exports = __webpack_public_path__ + "static/voting-d03996ea4a4dbc84eaa4007ea91f3072.svg";